module.exports = __webpack_public_path__ + "img/continent.1000.8f315a20.png";